<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout>
                <v-flex xs12 sm6>
                    <div>
                        <v-btn class="no-print" @click="newMonitoreoCs" large color="primary">Nueva hoja</v-btn>
                    </div>
                </v-flex>
            </v-layout>
            <br>
            <br>
            <v-layout>
                <v-flex xs12 sm6 offset-sm1>
                    <v-select
                            v-model="monitoreoCs"
                            :items="listMonitoreoCs"
                            label="Historial"
                            item-text="fecha"
                            @change="loadDataOnSelect"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <br>
                <v-expansion-panel v-model="panel" expand v-if="monitoreoCs!=null">
                    <v-expansion-panel-content v-for="item in monitoreoCs.lista" v-bind:key="item.id">
                        <template v-slot:header>
                            <div>{{item.encabezado}}</div>
                        </template>
                        <v-layout>
                            <v-flex xs12 sm10 offset-sm1>
                                <v-data-table
                                        ref="tableData"
                                        :items="item.datos"
                                        class="elevation-1"
                                        hide-actions
                                        hide-headers
                                >
                                    <template slot="items" slot-scope="props">
                                        <td class="text-xs-left">
                                            <br v-if="number==8">
                                            <p v-if="props.item.tipo==20" class="font-weight-bold">a. Datos de
                                                filiación</p>
                                            <p v-if="props.item.tipo==21" class="font-weight-bold">Identificación:
                                                {{$store.state.patient.identification}}</p>
                                            <p v-if="props.item.tipo==22" class="font-weight-bold">Apellidos y nombres:
                                                {{$store.state.patient.firstLastName}}
                                                {{$store.state.patient.secondLastName}}
                                                {{$store.state.patient.firstName}}
                                                {{$store.state.patient.secondName}} </p>
                                            <p v-if="props.item.tipo==23" class="font-weight-bold">Edad:
                                                {{$store.state.patient.age}}</p>
                                            <p v-if="props.item.tipo==24" class="font-weight-bold">Empresa:
                                                {{$store.state.patient.company.name}}</p>
                                            <p v-if="props.item.tipo==25" class="font-weight-bold">Puesto de trabajo:
                                                {{$store.state.patient.jobCompany}}</p>
                                            <p v-if="props.item.tipo==0 && !props.item.bold">{{props.item.label}}</p>
                                            <p v-if="props.item.tipo==0 && props.item.bold" class="font-weight-bold">
                                                {{props.item.label}}</p>

                                            <v-select
                                                    v-if="props.item.tipo==1"
                                                    :items="props.item.data"
                                                    v-model="props.item.valor"
                                                    :label="props.item.label"
                                                    :style="props.item.color"
                                                    :rules="[v => !!v || 'Es requerido']"
                                                    required
                                            ></v-select>
                                            <v-select
                                                    v-if="props.item.tipo==2"
                                                    :items="props.item.data"
                                                    v-model="props.item.valor"
                                                    :label="props.item.label"
                                                    :rules="[v => !!v || 'Es requerido']"
                                                    required
                                            ></v-select>
                                            <v-text-field
                                                    v-if="props.item.tipo==2"
                                                    :label="props.item.label2"
                                                    v-model="props.item.valor2"
                                                    required
                                            ></v-text-field>
                                            <v-text-field
                                                    v-if="props.item.tipo==3"
                                                    :label="props.item.label"
                                                    v-model="props.item.descripcion"
                                                    required
                                            ></v-text-field>
                                            <v-textarea
                                                    v-if="props.item.tipo==4"
                                                    :label="props.item.label"
                                                    v-model="props.item.descripcion"
                                                    required
                                            ></v-textarea>
                                            <v-btn color="primary" v-if="props.item.tipo==5"
                                                   @click="calculo(props.item.click)" dark>
                                                {{props.item.label}}
                                            </v-btn>

                                            <!--Componente específico-->
                                            <p v-if="props.item.tipo==6" class="font-weight-bold">
                                                {{props.item.label}}</p>
                                            <select :id="props.item.descripcion" v-if="props.item.tipo==6" :value="props.item.valor"
                                                    @change="seleccionaValorNdi(props.item)" required="">
                                                <option value="" class="white" selected="">Seleccionar</option>
                                                <option value="0" style="background-color: greenyellow">
                                                    {{props.item.data[0]}}
                                                </option>
                                                <option value="1" style="background-color: greenyellow">
                                                    {{props.item.data[1]}}
                                                </option>
                                                <option value="2" style="background-color: yellow">
                                                    {{props.item.data[2]}}
                                                </option>
                                                <option value="3" style="background-color: yellow">
                                                    {{props.item.data[3]}}
                                                </option>
                                                <option value="4" style="background-color: red">{{props.item.data[4]}}
                                                </option>
                                                <option value="5" style="background-color: red">{{props.item.data[5]}}
                                                </option>
                                            </select>


                                            <table v-if="props.item.tipo==7" border="1" cellspacing="0">
                                                <tbody>
                                                <tr>
                                                    <td>PLIEGUE CUTÁNEO</td>
                                                    <td>TOMA #1</td>
                                                    <td>TOMA #2</td>
                                                    <td>TOMA #3</td>
                                                    <td>PROMEDIO</td>
                                                </tr>
                                                <tr>
                                                    <td>BICIPITAL</td>
                                                    <td>
                                                        <v-text-field v-model="props.item.valor1"/>
                                                    </td>
                                                    <td>
                                                        <v-text-field v-model="props.item.valor2"/>
                                                    </td>
                                                    <td>
                                                        <v-text-field v-model="props.item.valor3"/>
                                                    </td>
                                                    <td>
                                                        <span>{{props.item.valor4=((parseFloat(props.item.valor1)+parseFloat(props.item.valor2)+parseFloat(props.item.valor3))/3).toFixed(2)}}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>TRICIPITAL</td>
                                                    <td>
                                                        <v-text-field v-model="props.item.valor5"/>
                                                    </td>
                                                    <td>
                                                        <v-text-field v-model="props.item.valor6"/>
                                                    </td>
                                                    <td>
                                                        <v-text-field v-model="props.item.valor7"/>
                                                    </td>
                                                    <td>
                                                        <span>{{props.item.valor8=((parseFloat(props.item.valor5)+parseFloat(props.item.valor6)+parseFloat(props.item.valor7))/3).toFixed(2)}}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>SUBESCAPULAR</td>
                                                    <td>
                                                        <v-text-field v-model="props.item.valor9"/>
                                                    </td>
                                                    <td>
                                                        <v-text-field v-model="props.item.valor10"/>
                                                    </td>
                                                    <td>
                                                        <v-text-field v-model="props.item.valor11"/>
                                                    </td>
                                                    <td>
                                                        <span>{{props.item.valor12=((parseFloat(props.item.valor9)+parseFloat(props.item.valor10)+parseFloat(props.item.valor11))/3).toFixed(2)}}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>SUPRAILÍACO</td>
                                                    <td>
                                                        <v-text-field v-model="props.item.valor13"/>
                                                    </td>
                                                    <td>
                                                        <v-text-field v-model="props.item.valor14"/>
                                                    </td>
                                                    <td>
                                                        <v-text-field v-model="props.item.valor15"/>
                                                    </td>
                                                    <td>
                                                        <span>{{props.item.valor16=((parseFloat(props.item.valor13)+parseFloat(props.item.valor14)+parseFloat(props.item.valor15))/3).toFixed(2)}}</span>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>

                                            <div v-if="props.item.tipo==8">
                                                <score-sd></score-sd>
                                            </div>
                                            <div v-if="props.item.tipo==9">
                                                <score-framinghan></score-framinghan>
                                            </div>
                                            <div>
                                                <iframe v-if="props.item.tipo==10"
                                                        src="https://chatbot-credito.s3-sa-east-1.amazonaws.com/machineLearning/SUSETOISTAS21.pdf"
                                                        frameborder="0" height="500px" width="100%"></iframe>
                                            </div>
                                            <img v-if="props.item.tipo==11 && props.item.imagen==1"
                                                 src="../../../assets/files/ERITEMA.jpg" frameborder="0" height="100px"
                                                 width="100px"/>
                                            <img v-if="props.item.tipo==11 && props.item.imagen==2"
                                                 src="../../../assets/files/MACULAS.jpg" frameborder="0" height="100px"
                                                 width="100px"/>
                                            <img v-if="props.item.tipo==11 && props.item.imagen==3"
                                                 src="../../../assets/files/VESICULA.jpg" frameborder="0" height="100px"
                                                 width="100px"/>
                                            <img v-if="props.item.tipo==11 && props.item.imagen==4"
                                                 src="../../../assets/files/ESCAMAS.jpg" frameborder="0" height="100px"
                                                 width="100px"/>
                                            <img v-if="props.item.tipo==11 && props.item.imagen==5"
                                                 src="../../../assets/files/FISURAS.jpg" frameborder="0" height="100px"
                                                 width="100px"/>

                                            <p v-if="props.item.tipo==12">{{props.item.label}}</p>
                                            <v-menu v-if="props.item.tipo==12"
                                                    ref="menu2"
                                                    :close-on-content-click="false"
                                                    v-model="menu2"
                                                    :nudge-right="40"
                                                    :return-value.sync="date"
                                                    lazy
                                                    transition="scale-transition"
                                                    offset-y
                                                    full-width
                                                    min-width="290px">
                                                <v-text-field
                                                        slot="activator"
                                                        v-model="props.item.valor"
                                                        label="Fecha de Admisión"
                                                        prepend-icon="event"
                                                        readonly
                                                ></v-text-field>
                                                <v-date-picker v-model="props.item.valor"
                                                               @input="$refs.menu2.save(props.item.valor)"></v-date-picker>
                                            </v-menu>
                                            <div v-if="props.item.tipo==13">
                                                <v-btn color="primary"
                                                       @click="calculoValorEnergetico()" dark>
                                                    Calcular
                                                </v-btn>
                                                <p  class="font-weight-bold">Gasto Energético: {{valorEnergetico}}</p>
                                            </div>
                                            <v-select
                                                    v-if="props.item.tipo==14"
                                                    :items="props.item.data"
                                                    v-model="props.item.valor"
                                                    :label="props.item.label"
                                            ></v-select>
                                        </td>
                                    </template>
                                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                        No se han encontrado resultados para "{{ search }}".
                                    </v-alert>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-expansion-panel-content>
                </v-expansion-panel>
        </v-form>
        <div class="text-xs-center" v-if="monitoreoCs!=null">
            <v-btn color="primary" class="no-print" @click="deleteMonitoreoCs" dark>Eliminar Registro</v-btn>
            <v-btn color="primary" class="no-print" @click="saveMonitoreoCs" dark>Guardar</v-btn>
        </div>
        <v-dialog
                v-model="dialogError"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>{{this.errorMessage==""?'Por favor verifique la información requerida para continuar.':this.errorMessage}}</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogError = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogSuccess"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Se guardó con exito la información</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogSuccess = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>

    import MonitoreoRespiratorioCs from "../../../model/MonitoreoRespiratorioCs"
    import MonitoreoDermatológicoCs from "../../../model/MonitoreoDermatológicoCs";
    import MonitoreoDermatológicoNged from "../../../model/MonitoreoDermatológicoNged";
    import MonitoreoMusculoEsqueleticoCs from "../../../model/MonitoreoMusculoEsqueleticoCs";
    import MonitoreoMusculoEsqueleticoQuickDash from "../../../model/MonitoreoMusculoEsqueleticoQuickDash";
    import MonitoreoMusculoEsqueleticoRolandMorris from "../../../model/MonitoreoMusculoEsqueleticoRolandMorris";
    import MonitoreoMusculoEsqueleticoNordico from "../../../model/MonitoreoMusculoEsqueleticoNordico";
    import MonitoreoMusculoEsqueleticoNdi from "../../../model/MonitoreoMusculoEsqueleticoNdi";
    import MonitoreoSaludMentalAnsiedadDepresion from "../../../model/MonitoreoSaludMentalAnsiedadDepresion";
    import MonitoreoSaludMentalCuestionario16 from "../../../model/MonitoreoSaludMentalCuestionario16";
    import MonitoreoOftalmologicoCs from "../../../model/MonitoreoOftalmologicoCs";
    import MonitoreoOftalmologicoOsdi from "../../../model/MonitoreoOftalmologicoOsdi";
    import PatientMonitoring from "../../../model/PatientMonitoring";
    import MonitoreoNutricionalCs from "../../../model/MonitoreoNutricionalCs";
    import ScoreSd from "./metabolico/ScoreSd";
    import ScoreFraminghan from "./metabolico/ScoreFraminghan";
    import MonitoreoNutricionalScoreSdoCs from "../../../model/MonitoreoNutricionalScoreSd";
    import MonitoreoNutricionalScoreFraminghan from "../../../model/MonitoreoNutricionalScoreFraminghan";
    import MonitoreoSaludMentalSuseto from "../../../model/MonitoreoSaludMentalSuseto";
    import CuestionarioProessat from "../../../model/CuestionarioProessat"
    import pdf from 'vue-pdf'

    export default {
        components: {
            ScoreSd,
            ScoreFraminghan,
            pdf
        },
        props: ['number'],
        data() {
            return {
                panel:[true,true,true,true,true,true,true,true,true,true,true,true,true,true,true],
                monitoreoCs: null,
                listMonitoreoCs: [],
                radioGroup: 1,
                search: '',
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                jobs: [],
                dialogSuccess: false,
                patientMonitoring: null,
                dialogError: false,
                dialogSucess: false,
                menu2: false,
                valorEnergetico: 0,
                errorMessage: ""
            };
        },
        methods: {
            newMonitoreoCs() {
                let d = new Date();
                let e = this.formatDate(d);
                switch (this.number) {
                    case 4:
                        this.monitoreoCs = new MonitoreoRespiratorioCs()
                        break;
                    case 5:
                        this.monitoreoCs = new MonitoreoDermatológicoCs()
                        break;
                    case 6:
                        this.monitoreoCs = new MonitoreoDermatológicoNged()
                        break;
                    case 7:
                        this.monitoreoCs = new MonitoreoMusculoEsqueleticoCs()
                        break;
                    case 8:
                        this.monitoreoCs = new MonitoreoMusculoEsqueleticoQuickDash()
                        break;
                    case 9:
                        this.monitoreoCs = new MonitoreoMusculoEsqueleticoRolandMorris()
                        break;
                    case 10:
                        this.monitoreoCs = new MonitoreoMusculoEsqueleticoNordico()
                        break;
                    case 11:
                        this.monitoreoCs = new MonitoreoMusculoEsqueleticoNdi()
                        break;
                    case 12:
                        this.monitoreoCs = new MonitoreoSaludMentalAnsiedadDepresion()
                        break;
                    case 13:
                        this.monitoreoCs = new MonitoreoSaludMentalCuestionario16()
                        break;
                    case 14:
                        this.monitoreoCs = new MonitoreoOftalmologicoCs()
                        break;
                    case 15:
                        this.monitoreoCs = new MonitoreoOftalmologicoOsdi()
                        break;
                    case 20:
                        this.monitoreoCs = new MonitoreoNutricionalCs()
                        break;
                    case 21:
                        this.monitoreoCs = new MonitoreoNutricionalScoreSdoCs()
                        break;
                    case 22:
                        this.monitoreoCs = new MonitoreoNutricionalScoreFraminghan()
                        break;
                    case 23:
                        this.monitoreoCs = new MonitoreoSaludMentalSuseto()
                        break;
                    case 37:
                        this.monitoreoCs = new CuestionarioProessat()
                        break;
                    default:
                        this.monitoreoCs = new MonitoreoRespiratorioCs()
                }
                this.monitoreoCs.fecha = e
                this.listMonitoreoCs.push(this.monitoreoCs)
            },

            saveMonitoreoCs() {
                if (this.isValidateForm(this.number)) {
                        this.$store.state.patientMonitoringList = []
                        if (this.monitoreoCs.id != '' && this.monitoreoCs.id != null) {
                            this.$store.dispatch('getPatientMonitoring', this.monitoreoCs.id).then(response => {
                                this.$store.state.patientMonitoringOne.value = JSON.stringify(this.monitoreoCs)
                                this.$store.dispatch('updatePatientMonitoring', this.$store.state.patientMonitoringOne).then(response => {
                                    this.dialogSuccess = true
                                    this.reloadData()
                                }, error => {
                                    this.$store.state.progress = false
                                    this.$store.state.dialogError = true
                                })
                            })
                        } else {
                            let monitoringNew = new PatientMonitoring()
                            monitoringNew.date = new Date()
                            monitoringNew.value = JSON.stringify(this.monitoreoCs)
                            monitoringNew.form = this.number
                            monitoringNew.patientRouteSheet = this.$store.state.routeSheet
                            this.$store.dispatch('addPatientMonitoring', monitoringNew).then(response => {
                                this.dialogSuccess = true
                                this.reloadData()
                            }, error => {
                                this.$store.state.progress = false
                                this.$store.state.dialogError = true
                            })
                        }
                } else {
                    this.dialogError = true
                }

            },

            isValidateForm(formNumber){
                if(formNumber==10){
                    if(this.monitoreoCs.lista[1].datos[1].valor=='' || this.monitoreoCs.lista[1].datos[2].valor==''|| this.monitoreoCs.lista[1].datos[3].valor==''|| this.monitoreoCs.lista[1].datos[4].valor==''|| this.monitoreoCs.lista[1].datos[5].valor==''|| this.monitoreoCs.lista[1].datos[6].valor==''|| this.monitoreoCs.lista[1].datos[7].valor==''|| this.monitoreoCs.lista[1].datos[8].valor=='') {
                        this.errorMessage = 'Para guardar debe completar la primera sección.'
                        return false
                    }else{
                        for(let i=1; i<10;i++){
                            if (this.monitoreoCs.lista[1].datos[i].valor == 'SI' &&
                                (this.monitoreoCs.lista[1].datos[i+9].valor==''||
                                    this.monitoreoCs.lista[1].datos[i+18].valor==''||
                                    this.monitoreoCs.lista[1].datos[i+27].valor==''||
                                    this.monitoreoCs.lista[1].datos[i+36].valor==''||
                                    this.monitoreoCs.lista[1].datos[i+45].valor==''||
                                    this.monitoreoCs.lista[1].datos[i+54].valor==''||
                                    this.monitoreoCs.lista[1].datos[i+63].valor==''||
                                    this.monitoreoCs.lista[1].datos[i+72].valor==''||
                                    this.monitoreoCs.lista[1].datos[i+81].descripcion=='')) {
                                this.errorMessage = 'Para guardar debe completar todos los campos referentes a '+this.monitoreoCs.lista[1].datos[i].label
                                return false
                            }
                        }
                        return true
                    }
                }else{
                    return this.$refs.form.validate()
                }
                return true
            },

            deleteMonitoreoCs() {
                confirm('Está seguro de que quiere eliminar el registro?') && this.$store.dispatch('deletePatientMonitoring', this.monitoreoCs.id).then(response => {
                    this.reloadData()
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },

            reloadData() {
                let data = new PatientMonitoring()
                data.form = this.number
                data.patientRouteSheet = this.$store.state.routeSheet
                data.date = new Date()
                data.value = ""
                this.monitoreoCs = null
                this.$store.dispatch('getPatientMonitoringByRouteSheetForm', data).then(response => {
                    this.listMonitoreoCs = []
                    for (let i = 0; i < this.$store.state.patientMonitoringList.length; i++) {
                        let anam = JSON.parse(this.$store.state.patientMonitoringList[i].value)
                        anam.id = this.$store.state.patientMonitoringList[i].id
                        this.loadSpecificDataFlow(anam)
                        this.listMonitoreoCs.push(anam)
                    }
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })

            },

            loadSpecificDataFlow(data) {
                if (this.number == 4) {
                    var today = new Date();
                    var yyyy = today.getFullYear();
                    let hasExamTorax = false
                    let hasExamEspirometria = false

                    for (let i = 0; i < this.$store.state.patientFileList.length; i++) {
                        if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("TORAX") || this.$store.state.patientFileList[i].group.includes("TÓRAX"))) {
                            hasExamTorax = true
                        }
                        if (this.$store.state.patientFileList[i].year == yyyy && (this.$store.state.patientFileList[i].group.includes("ESPIROMETRIA") || this.$store.state.patientFileList[i].group.includes("ESPIROMETRÍA"))) {
                            hasExamEspirometria = true
                        }
                    }
                    if (hasExamTorax) {
                        data.lista[6].datos[0].label = "SI"
                        data.lista[6].datos[1].tipo = 4
                    } else {
                        data.lista[6].datos[0].label = "NO"
                        data.lista[6].datos[1].tipo = 0
                    }
                    if (hasExamEspirometria) {
                        data.lista[7].datos[0].label = "SI"
                        data.lista[7].datos[1].tipo = 4
                    } else {
                        data.lista[7].datos[0].label = "NO"
                        data.lista[7].datos[1].tipo = 0
                    }
                }
            },
           loadDataOnSelect(){
              //Realiza calculo de quickdash para calculos mal guardados anteriormente
             if(this.number == 8 && this.monitoreoCs.lista[1].datos[2].valor!=""){
               this.calculo(4)
              }else if(this.number==15){
               this.calculo(7)
             }
            },

            formatDate(date) {
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var seconds = date.getSeconds();
                var ampm = hours >= 12 ? 'pm' : 'am';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0' + minutes : minutes;
                var strTime = hours + ':' + minutes + ":" + seconds + ' ' + ampm;
                return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
            },

            seleccionaValorNdi(item) {
                var e = document.getElementById(item.descripcion);
                item.valor = e.options[e.selectedIndex].value;
            },
            calculo(tipo) {
                //Cuestionario Q16
                if (tipo == 1) {
                    let puntaje = 0
                    for (let i = 0; i < this.monitoreoCs.lista[1].datos.length; i++) {
                        if (this.monitoreoCs.lista[1].datos[i].valor === "SI") {
                            puntaje++
                        }
                    }
                    this.monitoreoCs.lista[1].datos[17].descripcion = puntaje
                }
                //Guía GOLDBERG GHQ12
                if (tipo == 2) {
                    let puntaje = 0
                    for (let i = 0; i < this.monitoreoCs.lista[1].datos.length; i++) {
                        if (this.monitoreoCs.lista[1].datos[i].valor === "Menos que lo habitual"
                            || this.monitoreoCs.lista[1].datos[i].valor === "Menos capaz que lo habitual"
                            || this.monitoreoCs.lista[1].datos[i].valor === "Menos feliz que lo habitual"
                            || this.monitoreoCs.lista[1].datos[i].valor === "Mucho menos que lo habitual"
                            || this.monitoreoCs.lista[1].datos[i].valor === "Mucho menos capaz que lo habitual"
                            || this.monitoreoCs.lista[1].datos[i].valor === "Mucho menos feliz que lo habitual") {
                            puntaje++
                        }
                    }
                    this.monitoreoCs.lista[1].datos[13].descripcion = puntaje
                }
                //Guía GOLDBERG GHQ12
                if (tipo == 3) {
                    let puntajeS = 0
                    if (this.monitoreoCs.lista[1].datos[3].valor === "Inocuo") {
                        puntajeS = 1
                    } else if (this.monitoreoCs.lista[1].datos[3].valor === "Irritante") {
                        puntajeS = 10
                    } else if (this.monitoreoCs.lista[1].datos[3].valor === "Nocivo") {
                        puntajeS = 100
                    } else if (this.monitoreoCs.lista[1].datos[3].valor === "Tóxico") {
                        puntajeS = 1000
                    } else if (this.monitoreoCs.lista[1].datos[3].valor === "Muy Tóxico") {
                        puntajeS = 10000
                    }
                    let puntajePCA = 0
                    if (this.monitoreoCs.lista[1].datos[4].valor === "una mano") {
                        puntajePCA = 1
                    } else if (this.monitoreoCs.lista[1].datos[4].valor === "ambas manos o una mano y el antebrazo") {
                        puntajePCA = 2
                    } else if (this.monitoreoCs.lista[1].datos[4].valor === "ambas manos y el antebrazo o un brazo completo") {
                        puntajePCA = 3
                    } else if (this.monitoreoCs.lista[1].datos[4].valor === "miembros superiores y el torso o las piernas") {
                        puntajePCA = 10
                    }
                    let puntajeT = 0
                    if (this.monitoreoCs.lista[1].datos[5].valor === "Menos de 30 minutos por día") {
                        puntajeT = 1
                    } else if (this.monitoreoCs.lista[1].datos[5].valor === "De 30 minutos a 2 horas por día") {
                        puntajeT = 2
                    } else if (this.monitoreoCs.lista[1].datos[5].valor === "De 2 a 6 horas por día") {
                        puntajeT = 5
                    } else if (this.monitoreoCs.lista[1].datos[5].valor === "Más de 6 horas por día") {
                        puntajeT = 10
                    }
                    this.monitoreoCs.lista[1].datos[6].descripcion = (puntajeS * puntajePCA * puntajeT)
                }


                //Guía QUICK DASH
                if (tipo == 4) {
                    let puntaje = 0
                    for (let i = 0; i < 15; i++) {
                        if (this.monitoreoCs.lista[1].datos[i].valor === "Ninguna dificultad"
                            || this.monitoreoCs.lista[1].datos[i].valor === "En absoluto"
                            || this.monitoreoCs.lista[1].datos[i].valor === "Ninguno"
                            || this.monitoreoCs.lista[1].datos[i].valor === "Ninguna dificultad") {
                            puntaje++
                        }
                        if (this.monitoreoCs.lista[1].datos[i].valor === "Poca dificultad"
                            || this.monitoreoCs.lista[1].datos[i].valor === "Poco"
                            || this.monitoreoCs.lista[1].datos[i].valor === "Leve"
                            || this.monitoreoCs.lista[1].datos[i].valor === "Poca dificultad") {
                            puntaje = puntaje + 2
                        }
                        if (this.monitoreoCs.lista[1].datos[i].valor === "Mediana dificultad"
                            || this.monitoreoCs.lista[1].datos[i].valor === "Moderadamente"
                            || this.monitoreoCs.lista[1].datos[i].valor === "Mediano"
                            || this.monitoreoCs.lista[1].datos[i].valor === "Mediana dificultad") {
                            puntaje = puntaje + 3
                        }
                        if (this.monitoreoCs.lista[1].datos[i].valor === "Mucha dificultad"
                            || this.monitoreoCs.lista[1].datos[i].valor === "Bastante"
                            || this.monitoreoCs.lista[1].datos[i].valor === "Fuerte"
                            || this.monitoreoCs.lista[1].datos[i].valor === "Muy limitado"
                            || this.monitoreoCs.lista[1].datos[i].valor === "Fuerte dificultad") {
                          console.log(this.monitoreoCs.lista[1].datos[i].valor)
                            puntaje = puntaje + 4
                        }
                        if (this.monitoreoCs.lista[1].datos[i].valor === "Incapaz"
                            || this.monitoreoCs.lista[1].datos[i].valor === "Demasiado"
                            || this.monitoreoCs.lista[1].datos[i].valor === "Muy Fuerte"
                            || this.monitoreoCs.lista[1].datos[i].valor === "Muy fuerte dificultad para dormir") {
                            puntaje = puntaje + 5
                        }
                    }
                    this.monitoreoCs.lista[1].datos[15].descripcion = puntaje

                    let puntaje2 = 0
                    for (let i = 15; i < this.monitoreoCs.lista[1].datos.length; i++) {
                        if (this.monitoreoCs.lista[1].datos[i].valor === "Ninguna dificultad") {
                            puntaje2++
                        }
                        if (this.monitoreoCs.lista[1].datos[i].valor === "Poca dificultad") {
                            puntaje2 = puntaje2 + 2
                        }
                        if (this.monitoreoCs.lista[1].datos[i].valor === "Mediana dificultad") {
                            puntaje2 = puntaje2 + 3
                        }
                        if (this.monitoreoCs.lista[1].datos[i].valor === "Mucha dificultad") {
                            puntaje2 = puntaje2 + 4
                        }
                        if (this.monitoreoCs.lista[1].datos[i].valor === "Muy fuerte dificultad") {
                            puntaje2 = puntaje2 + 5
                        }
                    }
                    this.monitoreoCs.lista[1].datos[22].descripcion = puntaje2

                }
                //ROLAND MORRIS
                if (tipo == 5) {
                    let puntaje = 0
                    for (let i = 0; i < this.monitoreoCs.lista[1].datos.length; i++) {
                        if (this.monitoreoCs.lista[1].datos[i].valor === "SI") {
                            puntaje++
                        }
                    }
                    this.monitoreoCs.lista[1].datos[25].descripcion = puntaje
                }

                //NDI
                if (tipo === 6) {
                    let puntaje = 0
                    for (let i = 0; i < this.monitoreoCs.lista[1].datos.length; i++) {
                        if (this.monitoreoCs.lista[1].datos[i].valor === '0') {
                        } else if (this.monitoreoCs.lista[1].datos[i].valor === '1') {
                            puntaje = puntaje + 1
                        } else if (this.monitoreoCs.lista[1].datos[i].valor === '2') {
                            puntaje = puntaje + 2
                        } else if (this.monitoreoCs.lista[1].datos[i].valor === '3') {
                            puntaje = puntaje + 3
                        } else if (this.monitoreoCs.lista[1].datos[i].valor === '4') {
                            puntaje = puntaje + 4
                        } else if (this.monitoreoCs.lista[1].datos[i].valor === '5') {
                            puntaje = puntaje + 5
                        }
                    }
                    let porcentaje = puntaje * 100 / 50
                    this.monitoreoCs.lista[1].datos[11].descripcion = puntaje
                    this.monitoreoCs.lista[1].datos[12].descripcion = porcentaje

                }
                //OSDI
                if (tipo == 7) {
                    let numPreguntas = 0
                    let puntaje = 0
                    for (let i = 1; i < 6; i++) {
                        if (this.monitoreoCs.lista[1].datos[i].valor === "Nunca") {

                        } else if (this.monitoreoCs.lista[1].datos[i].valor === "A veces") {
                           puntaje++
                        } else if (this.monitoreoCs.lista[1].datos[i].valor === "La mitad del tiempo") {
                            puntaje = puntaje + 2
                        } else if (this.monitoreoCs.lista[1].datos[i].valor === "La mayor parte del tiempo") {
                            puntaje = puntaje + 3
                        } else if (this.monitoreoCs.lista[1].datos[i].valor === "Todo el tiempo") {
                            puntaje = puntaje + 4
                        }
                    }
                    this.monitoreoCs.lista[1].datos[6].descripcion = puntaje

                    let puntaje2 = 0
                    for (let i = 8; i < 12; i++) {
                        if (this.monitoreoCs.lista[1].datos[i].valor === "Nunca") {

                        } else if (this.monitoreoCs.lista[1].datos[i].valor === "A veces") {
                            puntaje2++
                        } else if (this.monitoreoCs.lista[1].datos[i].valor === "La mitad del tiempo") {
                            puntaje2 = puntaje2 + 2
                        } else if (this.monitoreoCs.lista[1].datos[i].valor === "La mayor parte del tiempo") {
                            puntaje2 = puntaje2 + 3
                        } else if (this.monitoreoCs.lista[1].datos[i].valor === "Todo el tiempo") {
                            puntaje2 = puntaje2 + 4
                        }
                    }
                    this.monitoreoCs.lista[1].datos[12].descripcion = puntaje2

                    let puntaje3 = 0
                    for (let i = 14; i < 17; i++) {
                        if (this.monitoreoCs.lista[1].datos[i].valor === "Nunca") {

                        } else if (this.monitoreoCs.lista[1].datos[i].valor === "A veces") {
                          puntaje3++
                        } else if (this.monitoreoCs.lista[1].datos[i].valor === "La mitad del tiempo") {
                            puntaje3 = puntaje3 + 2
                        } else if (this.monitoreoCs.lista[1].datos[i].valor === "La mayor parte del tiempo") {
                            puntaje3 = puntaje3 + 3
                        } else if (this.monitoreoCs.lista[1].datos[i].valor === "Todo el tiempo") {
                            puntaje3 = puntaje3 + 4
                        }
                    }

                    for (let i = 0; i < this.monitoreoCs.lista[1].datos.length; i++) {
                        if (this.monitoreoCs.lista[1].datos[i].valor != "" ) {
                            numPreguntas++
                        }
                    }
                    this.monitoreoCs.lista[1].datos[17].descripcion = puntaje3
                    this.monitoreoCs.lista[1].datos[18].descripcion = (((puntaje3 + puntaje2 + puntaje) * 25) / 12).toFixed(2)

                }
            },
            calculoValorEnergetico(){
                this.$store.dispatch('getPatientAnamnesisByRouteSheets', this.$store.state.routeSheet.id).then(response => {
                    if(this.$store.state.anamnesisList.length>0){
                        let anam = JSON.parse(this.$store.state.anamnesisList[0].value)
                        if(this.$store.state.patient.gender=="M"){
                            this.valorEnergetico = (66.5+(13.8*parseFloat(anam.signosVitales[7].valor))+(5*parseFloat(anam.signosVitales[8].valor))-(6.8*parseFloat(this.$store.state.patient.age)))
                        }else{
                            this.valorEnergetico = (665+(9.6*parseFloat(anam.signosVitales[7].valor))+(1.85*parseFloat(anam.signosVitales[8].valor))-(4.7*parseFloat(this.$store.state.patient.age)))
                        }
                    }
                })
            },

        }
        ,
        computed: {

        },
        created() {
            this.reloadData()
        },
    }
</script>

<style scoped>
    li {
        list-style: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/patient/monitoreo/MonitoreoDinamico.vue